import { ApplicationFlows } from "./types";
import {
  BasicAccountApplicationDocument,
  CardApplicationDocument,
} from "../../../../api/commercial/generated-types";

export default function resolveFlow(
  basicAccountApplication: BasicAccountApplicationDocument,
  cardApplication: CardApplicationDocument,
  noValidApplications: boolean,
): ApplicationFlows {
  // resolve flow

  if (noValidApplications) {
    return ApplicationFlows.NO_APPLICATIONS_FLOW;
  }

  let flow;
  if (cardApplication && !basicAccountApplication) {
    flow = ApplicationFlows.ADDITIONAL_CA;
  } else if (basicAccountApplication) {
    // @ts-expect-error It exists. Problem with boolean mapping between backend and frontend.
    if (basicAccountApplication.first) {
      flow = ApplicationFlows.FIRST_BAA;
    } else {
      flow = ApplicationFlows.ADDITIONAL_BAA;
    }
  } else {
    throw new Error("Open applications in unknown state");
  }

  return flow;
}
